// This is an observer for the nav if there is a take over banner, it will react
// to it.
import ResizeObserver from 'resize-observer-polyfill'
import { dispatcher } from 'scripts/components/navigations/NavigationDispatcher'
import Constants from 'scripts/base/Constants'

class NavigationObserver {
  navbar = null
  takeoverClickable = null
  mainContainer = null
  navbar = null
  done = false
  lastPos = 0
  ro = null
  SCROLL_THRESHOLD = 600 // fall back
  TAKEOVER_CLICKABLE = 'takeover-clickable'
  CONTAINER_MAIN = 'container-main'

  constructor(selector) {
    this.navbar = document.getElementById(selector)
    this.takeoverClickable = document.getElementsByClassName(this.TAKEOVER_CLICKABLE)[0]
    this.mainContainer = document.getElementsByClassName(this.CONTAINER_MAIN)[0]

    if (!this.navbar || !this.mainContainer || !this.takeoverClickable) { return null }

    this.mainContainer.classList.add('no-floating-nav')
    document.body.style = 'margin-top: ' + this.takeoverClickable.offsetHeight + 'px;'

    window.addEventListener('scroll', this.scrolling, false)
    dispatcher.on(Constants.Navigations.TOGGLE_NAV, this.navToggle)
    this.initObserver()
  }

  initObserver() {
    const body = document.body
    this.ro = new ResizeObserver(elem => {
      window.requestAnimationFrame(() => {
        const takeoverClickable = document.getElementsByClassName(this.TAKEOVER_CLICKABLE)[0]
        if (takeoverClickable) {
          document.body.style = 'margin-top: ' + takeoverClickable.offsetHeight + 'px;'
        }
      })
    })

    this.ro.observe(body)
  }

  updateStyle() {
    const {navbar, takeoverClickable, lastPos, mainContainer} = this
    const heightThreshold = takeoverClickable ? takeoverClickable.offsetHeight : this.SCROLL_THRESHOLD

    if (lastPos >= heightThreshold) {
      navbar && navbar.classList.add('position-fixed')
      if (mainContainer) { mainContainer.classList.remove('no-floating-nav') }
    } else {
      navbar && navbar.classList.remove('position-fixed')
      if (mainContainer) { mainContainer.classList.add('no-floating-nav') }
    }
  }

  scrolling = () => {
    if (document.body.classList.contains('takeover')) {
      this.lastPos = window.scrollY
      this.requestUpdate()
    }
  }

  requestUpdate() {
    if (!this.done) {
      requestAnimationFrame(this.update)
    }
    this.done = true
  }

  update = () => {
    this.updateStyle()
    this.done = false
  }

  getCurrentScrollTop = () => {
    const doc = document.documentElement
    return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)
  }

  navToggle = (e) => {
    const active = document.getElementsByClassName('navbar-active')[0]
    if (active && this.getCurrentScrollTop() <= this.takeoverClickable.offsetHeight) {
      window.scrollTo(0, this.takeoverClickable.offsetHeight)
    }
  }

  destroy() {
    window.removeEventListener('scroll', this.scrolling)
    dispatcher.off(Constants.Navigations.TOGGLE_NAV, this.navToggle)
    this.navbar.classList.remove('position-fixed')
    document.body.style = 'margin-top: 0px;'
    this.ro = null
    this.navbar = null
    this.takeoverClickable = null
    this.mainContainer = null
    this.done = false
    this.lastPos = 0
  }
}

export default NavigationObserver



// WEBPACK FOOTER //
// ./assets/js/lib/NavigationObserver.js